<div class="center-wrapper">
	<img src="assets/img/falabella-logo.png" class="cw-logo" alt="">
	<h1 class="cw-title">¡Muchas gracias!</h1>
	<h3 class="cw-desc">Esperamos que hayas tenido una hermosa experiencia</h3>
</div>